import React from 'react'

// Path params enum
export enum RoutePathVariable {
  ResortKey = ':resortKey',
  TripId = ':tripId',
  ConfirmationNumber = ':confirmationNumber',
  CompKey = ':compKey',
}

// Route path patterns enum (all route strings, static and dynamic)
export enum RouterPathSegment {
  Root = '/',
  ExploreResorts = 'explore-resorts',
  Register = 'register',
  ResortMonthlyCalendar = `resort-monthly-calendar`,
  ComingSoon = 'comingSoon',
  Resorts = 'resorts',
  ResortsSearch = 'search',
  ResortsDestinations = 'destinations',
  Book = 'book',
  Account = 'account',
  AccountTrips = 'my-trips',
  AccountTripsModify = `modify`,
  AccountSavedSearches = 'saved-searches',
  AccountCredits = 'credits',
  AccountDuesLoans = 'dues-loans',
  AccountDuesLoansPayment = 'payment',
  AccountRciExchanges = 'rci-exchanges',
  AccountMyClub = 'my-club',
  AccountWishList = 'wish-list',
  AccountProfile = 'profile',
  AccountLogin = 'login',
  AccountLoginCallback = 'callback',
  AccountLogout = 'logout',
  Mako = 'mako',
  MakoCatalog = 'catalog',
  MakoCatalogAbout = 'about',
  MakoCatalogComps = 'comps',
  MakoDemo = 'mako/demo',
  MakoDemoComingSoon = 'comingSoon',
  MakoDemoAbout = 'about',
  MakoDemoResorts = 'demoResorts',
  AccountRCIExchanges = 'AccountRCIExchanges',
  AccountBucketList = 'AccountBucketList',
}

// Route config type
export type RouteConfig = {
  path?: (RouterPathSegment | RoutePathVariable)[]
  element: React.ReactNode
  index?: boolean
  children?: RouteConfig[]
}
